module.exports = __webpack_public_path__ + "img/sweat_face.4acdf6f.svg";